export const slideContainerStyles = {
  container: {
    backgroundColor: '#ffffff',
  },
  root: {
    backgroundColor: '#ffffff',
  },
  navigationNext: {
    borderRadius: '100%',
    backgroundColor: '#3d382e',
    padding: '10px',
    marginRight: '16px',
    fontSize: '20px',
  },
  navigationPrev: {
    marginLeft: '16px',
    borderRadius: '100%',
    backgroundColor: '#3d382e',
    padding: '10px',
    fontSize: '20px',
  },
  captionsDescriptionContainer: {
    backgroundColor: 'rgba(255, 255, 255,0.25)',
    borderTop: '1px solid #babebf',
  },
  captionsDescription: {
    color: '#3d382e',
    fontSize: '15px',
    fontWeight: 600,
    fontFamily: 'figtree',
  },
  toolbar: {
    backgroundColor: 'rgba(255, 255, 255,0.25)',
  },
  button: {
    filter: 'none',
  },
} as const;

export const slideHeaderButtonStyles = {
  toolbar: {
    top: '16px',
  },
} as const;

export const slideCounterStyles = {
  top: '0',
  left: '16px',
  paddingLeft: 0,
  marginLeft: 0,
  color: '#322D24',
  filter: 'none',
  fontSize: '18px',
  fontFamily: 'figtree',
  fontWeight: '500',
} as const;
